import './MobileTransactionHistoryFilters.scss';

import { arrayOf, object, oneOfType, string } from 'prop-types';
import React from 'react';
import { isObject } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
  selectHistoricalTransactionDateOptions,
  selectHistoricalTransactionTimePeriod,
  selectHistoricalTransactionIncludedAccounts,
  selectHistoricalTransactionTransactionType,
  TIME_PERIOD
} from 'state/transaction/TransactionActions';

import { initialTransactionsHistoryFilteringState } from 'state/transaction/TransactionReducers';

import {
  furthestDateFromReferenceDate,
  isValidInputDate,
  yyyymmdd
} from 'services/Dates';

import Store from 'state/Store';

import BaseModal from 'components/shared/Modal/BaseModal';

import MobileRadio from 'components/shared/Radio/MobileRadio';

import MobileDatePeriodSelect from 'components/shared/PeriodSelector/MobileDatePeriodSelect';

import MobileTimePeriodSelect from 'components/shared/PeriodSelector/MobileTimePeriodSelect';

import MobileRadioList from 'components/shared/Radio/MobileRadioList';
import {activityPageBeaconDatePickerEnabled} from 'services/FeatureFlags';

const selectDatePeriodBeacon = (fromDate, toDate) => {
  if (isValidInputDate(fromDate) && isValidInputDate(toDate)) {
    Store.dispatch(
      selectHistoricalTransactionDateOptions({
        fromDate,
        toDate
      })
    );
  } else if (!isValidInputDate(fromDate) && !isValidInputDate(toDate)) {
    const value =
      initialTransactionsHistoryFilteringState[TIME_PERIOD].selection;
    Store.dispatch(selectHistoricalTransactionTimePeriod(value));
  }
};

const selectDatePeriod = (state) => {
  const { fromDate, toDate } = state;
  if (isValidInputDate(fromDate) && isValidInputDate(toDate)) {
    Store.dispatch(
      selectHistoricalTransactionDateOptions({
        fromDate,
        toDate
      })
    );
  } else if (!isValidInputDate(fromDate) && !isValidInputDate(toDate)) {
    const value =
      initialTransactionsHistoryFilteringState[TIME_PERIOD].selection;
    Store.dispatch(selectHistoricalTransactionTimePeriod(value));
  }
};

const selectTimePeriod = (event) => {
  const value = event
    ? event
    : initialTransactionsHistoryFilteringState[TIME_PERIOD].selection;

  return Store.dispatch(selectHistoricalTransactionTimePeriod(value));
};

const selectIncludedAccounts = (event) =>
  Store.dispatch(selectHistoricalTransactionIncludedAccounts(event));

const IncludedAccountsSelect = ({ options, selection }) => (
  <div className="select-group e2e-group-by-select blocked_data">
    <p className="select-label">Included Accounts</p>

    {options.map((option, i) => (
      <MobileRadio
        key={i}
        option={option}
        onChange={selectIncludedAccounts}
        className="mobile-transaction-history-filter-radio-container"
        name="time-period"
        selected={selection}
      />
    ))}
  </div>
);

IncludedAccountsSelect.propTypes = {
  selection: string,
  options: arrayOf(oneOfType([string, object]))
};

const selectTransactionType = (event) =>
  Store.dispatch(selectHistoricalTransactionTransactionType(event));

const TransactionTypeSelect = ({ options, selection }) => (
  <div className="select-group e2e-filter-by-select">
    <p className="select-label">Transaction Type</p>

    {options.map((option, i) => (
      <MobileRadio
        key={i}
        option={option}
        onChange={selectTransactionType}
        className="mobile-transaction-history-filter-radio-container"
        name="time-period"
        selected={selection}
      />
    ))}
  </div>
);

TransactionTypeSelect.propTypes = {
  selection: string,
  options: arrayOf(oneOfType([string, object]))
};

class MobileTransactionHistoryFilters extends React.Component {
  state = {
    fromDate: '',
    showTimePeriodDropdown: true,
    toDate: ''
  };

  toggleTimePeriod = () => {
    this.setState(
      (prevState) => ({
        fromDate: '',
        showTimePeriodDropdown: !prevState.showTimePeriodDropdown,
        toDate: ''
      }),
      () => {
        if (this.state.showTimePeriodDropdown) {
          selectTimePeriod();
        }
      }
    );
  };

  toggleFromDate = (event) => {
    if(!activityPageBeaconDatePickerEnabled()) {
      this.setState(
        {
          fromDate: event.target.value
        },
        () => {
          selectDatePeriod(this.state);
        }
      );
    } else {
      this.setState(
        {
          fromDate: event
        }
      );
    }
  };

  toggleToDate = (event) => {
    if(!activityPageBeaconDatePickerEnabled()) {
      this.setState(
        {
          toDate: event.target.value
        },
        () => {
          selectDatePeriod(this.state);
        }
      );
    } else {
      this.setState(
        {
          toDate: event
        }
      );
    }
  };

  render() {
    const { close, filteringSelections, isOpen, rawTransactionsHistory } =
      this.props;

    const { showTimePeriodDropdown } = this.state;

    const minDate = furthestDateFromReferenceDate(rawTransactionsHistory);
    const maxDate = yyyymmdd();

    return (
      <BaseModal close={close} isOpen={isOpen} title="Filters" hideAnchor>
        <div className="mobile-transaction-history-filter-group">
          {showTimePeriodDropdown ? (
            <MobileTimePeriodSelect
              {...filteringSelections.timePeriod}
              className="mobile-transaction-history-filter-radio-container"
              onChange={selectTimePeriod}
              toggleTimePeriod={this.toggleTimePeriod}
            />
          ) : (
            <MobileDatePeriodSelect
              toggleTimePeriod={this.toggleTimePeriod}
              toggleFromDate={this.toggleFromDate}
              toggleToDate={this.toggleToDate}
              onChangeBeacon={selectDatePeriodBeacon}
              minDate={minDate}
              maxDate={maxDate}
              {...this.state}
            />
          )}
          <MobileRadioList
            className="mobile-transaction-history-filter-radio-container blocked_data"
            label="Included Accounts"
            onChange={selectIncludedAccounts}
            options={filteringSelections.includedAccounts.options}
            selection={filteringSelections.includedAccounts.selection}
          />
          <MobileRadioList
            className="mobile-transaction-history-filter-radio-container"
            label="Transaction Type"
            onChange={selectTransactionType}
            options={filteringSelections.transactionType.options}
            selection={filteringSelections.transactionType.selection}
          />
        </div>
      </BaseModal>
    );
  }
}

const mapStateToProps = ({
  transactionsHistoryFilteringSelections: filteringSelections,
  rawTransactionsHistory
}) => {
  const { includedAccounts: { options, selection } = {} } = filteringSelections;
  return {
    filteringSelections: {
      ...filteringSelections,
      includedAccounts: {
        options: options.filter((option) => isObject(option)), //filtering out the divider
        selection
      }
    },
    rawTransactionsHistory
  };
};

export default withRouter(
  connect(mapStateToProps)(MobileTransactionHistoryFilters)
);
